"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialToitEnPenteConfigurationState = void 0;
exports.initialToitEnPenteConfigurationState = {
    humanReadableName: null,
    toitClimate: {
        type: null,
        material: null,
    },
    toitStructure: {
        type: null,
        material: null,
    },
    toitRainCover: {
        type: null,
        material: null,
    },
    toitInsulation: {
        type: null,
        material: null,
    },
    toitAcousticLayer: {
        type: null,
        material: null,
    },
    files: {
        nl_be: null,
        fr_be: null,
        nl_nl: null,
        fr_fr: null,
        de_de: null,
        en_en: null,
    },
};
